module.exports = __webpack_public_path__ + "static/media/bottom_banner_11_1.3a383f7c.png";